// extracted by mini-css-extract-plugin
module.exports = {"content":"MonarchEnabled_content__YnemA"};